// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * This module provides workspace default value.
 *
 * @module js/swf3dWorkspaceDefaultValue
 */

// Define default values that used in toolkit.
var swf3dWorkspaceDefaultValue = {
    tableFilterList: ['prt', 'jt', 'cvf', 'fem', 'afm', 'sim', 'obj'],
    uploadFilterList: '.prt, .jt, .cvf, .fem, .afm, .sim',
    previewUrl: 'https://preview-service.pre2.usea1.istio.devops.sws.siemens.com/sendAPI',
    validTypeList: ['afm', 'cvf', 'fem', 'jt', 'prt', 'sim', 'obj']
};

export default swf3dWorkspaceDefaultValue;
